var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "4",
      "height": "79",
      "viewBox": "0 0 4 79",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.53125 2L2.46868 76.9941",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-dasharray": "4 4"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }